import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Tooltip } from "@material-ui/core";
import SupervisedUserCircleOutlinedIcon from "@material-ui/icons/SupervisedUserCircleOutlined";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  sendMessageIcons: { borderRadius: "20px", color: "grey", },
  checkedSendMessageIcons: { borderRadius: "20px", color: theme.palette.primary.pastel, },
}));

const InternalMessageIconContainer = ({
  isInternalMessage,
  setIsInternalMessage,
  userProfile,
  ticketReadOnly,
  ticketStatus
}) => {
  //  *************
  //  ** Classes **
  //  *************
  const classes = useStyles();



  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && ["i","I"].includes(event.key)) setIsInternalMessage(previousValue => !previousValue);
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [setIsInternalMessage]);



  //  ************
  //  ** Return **
  //  ************
  return (
    <Tooltip title={i18n.t("messagesInput.tooltips.internalMessage")} placement="top-start" arrow>
      <IconButton
        component="span"
        disabled={ticketReadOnly || ticketStatus === "closed" || (ticketStatus === "pending" && userProfile !== "admin")}
        onClick={() => setIsInternalMessage(previousValue => !previousValue)}
      >
        <SupervisedUserCircleOutlinedIcon
          className={isInternalMessage ? classes.checkedSendMessageIcons : classes.sendMessageIcons}
        />
      </IconButton>
    </Tooltip>
  );
};

export default InternalMessageIconContainer;
